import timeAgo from 'javascript-time-ago';
import en      from 'javascript-time-ago/locale/en';

timeAgo.locale(en);



// WEBPACK FOOTER //
// ./src/config/configureLocales.js